import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { API_URL, fetchWithAuth, getImageUrl } from '../api';
import { format } from 'date-fns';
import { X, Plus, Check, Music, Video, Globe, Clock, Trash2, Calendar, Star, ChevronDown } from 'react-feather';
import { FaDiscVinyl } from "react-icons/fa";

// --- COMPONENTE MODAL DE MÚSICA (Igual que antes) ---
const MUSIC_GENRES = [
  "Reggaeton", "Techno", "House", "Salsa", "Cumbia", 
  "Rock", "Pop", "Hip Hop", "Indie", "Electrónica", 
  "Pachanga", "Trap", "R&B", "Jazz", "80s & 90s"
];

const MusicTagsModal = ({ isOpen, onClose, selectedTags, onSave }) => {
    // ... (El código del modal de música se mantiene igual, cópialo del anterior si lo tienes)
    const [tempTags, setTempTags] = useState([]);
    useEffect(() => { if (isOpen) setTempTags(selectedTags || []); }, [isOpen, selectedTags]);
    const toggleTag = (tag) => {
        if (tempTags.includes(tag)) setTempTags(prev => prev.filter(t => t !== tag));
        else setTempTags(prev => [...prev, tag]);
    };
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4 animate-fade-in">
        <div className="bg-[#121217] border border-white/10 rounded-3xl w-full max-w-lg overflow-hidden shadow-2xl">
            <div className="p-6 border-b border-white/5 flex justify-between items-center">
            <h3 className="text-xl font-bold text-white flex items-center gap-2"><Music className="text-purple-400" size={20} />Estilo Musical</h3>
            <button onClick={onClose}><X size={20} className="text-gray-400 hover:text-white"/></button>
            </div>
            <div className="p-6 max-h-[60vh] overflow-y-auto custom-scrollbar flex flex-wrap gap-3">
            {MUSIC_GENRES.map((genre) => {
                const isSelected = tempTags.includes(genre);
                return (
                <button key={genre} onClick={() => toggleTag(genre)} className={`px-4 py-2 rounded-xl text-sm font-medium border flex items-center gap-2 transition-all ${isSelected ? 'bg-white text-black border-white scale-105' : 'bg-white/5 border-white/10 text-gray-400 hover:text-white'}`}>
                    {genre} {isSelected && <Check size={14} className="stroke-[3px]" />}
                </button>
                );
            })}
            </div>
            <div className="p-6 border-t border-white/5 bg-[#18181b] flex justify-end gap-3">
            <button onClick={onClose} className="px-6 py-2.5 rounded-xl text-gray-400 hover:text-white">Cancelar</button>
            <button onClick={() => { onSave(tempTags); onClose(); }} className="px-8 py-2.5 rounded-xl font-bold bg-white text-black hover:bg-gray-200">Guardar</button>
            </div>
        </div>
        </div>
    );
};

export default function CreateEvent() {
  const navigate = useNavigate();
  const { user } = useAuth();
  
  // States
  const [error, setError] = useState('');
  const [showError, setShowError] = useState(false);
  const [isValid, setIsValid] = useState(false);
  
  const [formData, setFormData] = useState({
    name: '', 
    date: '', 
    time: '', 
    description: '', 
    direction: '', 
    location: '',
    lineup: [], // AHORA ES UN ARRAY DE OBJETOS, NO STRING
    video: '', 
    tags: [], 
    age_limit: 18, 
    image_url: '', 
    private: false
  });

  // Modals
  const [showDateModal, setShowDateModal] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showTagsModal, setShowTagsModal] = useState(false); 
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [showLineupModal, setShowLineupModal] = useState(false);

  // Upload
  const fileInputRef = useRef(null);
  const [uploadLoading, setUploadLoading] = useState(false);

  // --- NUEVO ESTADO PARA EL LINEUP ---
  const [tempLineup, setTempLineup] = useState([]); 
  const [newGuestName, setNewGuestName] = useState('');
  const [newGuestTime, setNewGuestTime] = useState('');

  // Helpers
  const validateForm = (data) => Boolean(data.name && data.date && data.time && data.description && data.direction && data.image_url);
  const handleChange = (e) => { const n = { ...formData, [e.target.name]: e.target.value }; setFormData(n); setIsValid(validateForm(n)); };
  const handleModalUpdate = (updates) => { const n = { ...formData, ...updates }; setFormData(n); setIsValid(validateForm(n)); };

  // Generador de intervalos de 30 mins
  const timeOptions = [];
  for (let i = 0; i < 24; i++) {
      ['00', '30'].forEach(min => {
          const hour24 = i.toString().padStart(2, '0');
          const value = `${hour24}:${min}`; // Lo que va al backend: "22:30"
          
          const ampm = i < 12 ? 'AM' : 'PM';
          const hour12 = i === 0 ? 12 : i > 12 ? i - 12 : i;
          const label = `${hour12}:${min} ${ampm}`; // Lo que ve el usuario: "10:30 PM"
          
          timeOptions.push({ value, label });
      });
  }

  // --- LOGICA LINEUP ACTUALIZADA ---
  const addGuest = () => {
    if (newGuestName.trim()) {
      setTempLineup([...tempLineup, { 
        name: newGuestName.trim(), 
        time: newGuestTime || 'TBA' // TBA = To Be Announced
      }]);
      setNewGuestName('');
      setNewGuestTime('');
    }
  };

  const removeGuest = (index) => {
    setTempLineup(tempLineup.filter((_, i) => i !== index));
  };

  const handleSaveLineup = () => {
    // Guardamos el array de objetos directamente en formData.lineup
    // NOTA: Tu backend debe aceptar JSON en el campo lineup, o debes convertirlo a string aquí.
    // Si tu backend SOLO acepta string, usa: JSON.stringify(tempLineup)
    handleModalUpdate({ lineup: tempLineup }); 
    setShowLineupModal(false);
  };

  // --- UPLOAD LOGIC ---
  const handleImageUpload = async (file) => {
    if (!file) return;
    setUploadLoading(true);
    try {
      const uploadFormData = new FormData();
      uploadFormData.append('file', file);
      const res = await fetchWithAuth(`${API_URL}/events/upload-temp-image`, { method: 'POST', body: uploadFormData });
      handleModalUpdate({ image_url: res.image_url });
    } catch (err) { setError('Error subiendo imagen'); setShowError(true); } 
    finally { setUploadLoading(false); }
  };

  // --- SUBMIT ---
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
        const payload = formData;

        // 1. fetchWithAuth ya parsea el JSON, así que 'res' es tu modelo Event
        const res = await fetchWithAuth(`${API_URL}/events`, { 
            method: 'POST', 
            body: JSON.stringify(payload) 
        });

        // 2. Usamos el ID que viene en el modelo
        if (res && res.id) {
            navigate(`/event/${res.id}`);
        } else {
            // Fallback por si acaso el backend cambia de opinión
            console.warn("No se encontró ID en la respuesta:", res);
            navigate('/');
        }

        } catch (err) { 
            setError('Error al crear evento'); 
            setShowError(true); 
        }
    };

  if (!user) { navigate('/login'); return null; }

  return (
    <div className="min-h-[93vh] relative text-white overflow-hidden font-sans">
      
      {/* Background (Igual que antes) */}
      <div className="absolute inset-0 z-0 transition-all duration-700" style={{ 
        backgroundImage: formData.image_url ? `url('${getImageUrl(formData.image_url)}')` : `url('/backgrounds/bg_create2.png')`, 
        backgroundSize: 'cover', 
        backgroundPosition: 'center', 
        filter: 'blur(40px) saturate(150%) brightness(1.3)', 
        transform: 'scale(1.1)' 
    }} />
      <div className="fixed inset-0 z-[1] bg-black/40" />

      {/* --- MODAL LINEUP MEJORADO --- */}
      {showLineupModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-md p-4 animate-fade-in">
          <div className="bg-[#121217] border border-white/10 rounded-3xl w-full max-w-lg overflow-hidden shadow-2xl flex flex-col max-h-[80vh]">
            
            {/* Header con estilo */}
            <div className="p-6 pb-2">
                <div className="flex justify-between items-start">
                    <div>
                        <h3 className="text-2xl font-bold text-white flex items-center gap-2">
                            <Star className="text-white fill-white" size={24} />
                            Lineup & Horarios
                        </h3>
                        <p className="text-white/50 text-sm mt-1">Arma el cronograma de la fiesta.</p>
                    </div>
                    <button onClick={() => setShowLineupModal(false)} className="p-2 hover:bg-white/10 rounded-full transition-colors"><X size={20}/></button>
                </div>
            </div>

            {/* Lista Visual (Timeline) */}
            <div className="flex-1 overflow-y-auto custom-scrollbar p-6 pt-2">
                
                {/* Inputs para agregar */}
                <div className="bg-white/5 border border-white/10 rounded-2xl p-4 mb-6">
                    <div className="grid grid-cols-3 gap-3 mb-3">
                        <div className="col-span-2">
                            <label className="text-[10px] uppercase text-white/40 font-bold tracking-wider mb-1 block">Artista / DJ</label>
                            <input 
                                type="text" 
                                placeholder="Ej. DJ Peligro" 
                                value={newGuestName}
                                onChange={(e) => setNewGuestName(e.target.value)}
                                className="w-full bg-black/20 border border-white/10 rounded-lg px-3 py-2 text-sm text-white focus:border-white/40 outline-none"
                            />
                        </div>
                        <div className="col-span-1">
                            <label className="text-[10px] uppercase text-white/40 font-bold tracking-wider mb-1 block">Hora Inicio</label>
                            <input 
                                type="time" 
                                value={newGuestTime}
                                onChange={(e) => setNewGuestTime(e.target.value)}
                                className="w-full bg-black/20 border border-white/10 rounded-lg px-3 py-2 text-sm text-white focus:border-white/40 outline-none [color-scheme:dark]"
                            />
                        </div>
                    </div>
                    <button 
                        onClick={addGuest}
                        disabled={!newGuestName}
                        className={`w-full py-2.5 rounded-xl text-sm font-bold transition-all flex items-center justify-center gap-2
                            ${newGuestName ? 'bg-white text-black hover:bg-gray-200' : 'bg-white/5 text-white/20 cursor-not-allowed'}
                        `}
                    >
                        <Plus size={16} /> Agregar al Lineup
                    </button>
                </div>

                {/* Lista de Invitados */}
                {tempLineup.length === 0 ? (
                    <div className="text-center py-8 border border-dashed border-white/10 rounded-2xl">
                        <p className="text-white/30 text-sm">Aún no hay artistas agregados.</p>
                    </div>
                ) : (
                    <div className="space-y-3">
                        {tempLineup.map((guest, index) => (
                            <div key={index} className="flex items-center gap-4 group">
                                {/* Hora */}
                                <div className="w-16 text-right">
                                    <span className="block text-xs font-bold text-yellow-400">{guest.time}</span>
                                </div>
                                {/* Linea decorativa */}
                                <div className="w-[2px] h-10 bg-white/10 relative">
                                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 rounded-full bg-white/20 group-hover:bg-purple-400 transition-colors"></div>
                                </div>
                                {/* Tarjeta */}
                                <div className="flex-1 bg-white/5 hover:bg-white/10 border border-white/5 rounded-xl p-3 flex justify-between items-center transition-all">
                                    <span className="font-medium text-white">{guest.name}</span>
                                    <button onClick={() => removeGuest(index)} className="text-white/20 hover:text-red-400 p-1">
                                        <Trash2 size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Footer */}
            <div className="p-6 pt-2 bg-[#121217]">
                <button onClick={handleSaveLineup} className="w-full py-3 bg-white text-black font-bold rounded-xl hover:bg-gray-200 shadow-lg shadow-white/5">
                    Confirmar Lineup ({tempLineup.length})
                </button>
            </div>
          </div>
        </div>
      )}

      {/* --- OTROS MODALES (Date, Address, Video, Error) --- */}
      {/* ... (Pega aquí los otros modales: Error, Date, Address, Video, Tags) ... */}
      {showError && ( <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 p-4"><div className="bg-[#111] p-8 rounded-2xl border border-white/10 text-center"><div className="text-red-400 mb-4">{error}</div><button onClick={() => setShowError(false)} className="bg-white text-black px-6 py-2 rounded-xl">Ok</button></div></div> )}
      
      {showDateModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-md p-4 animate-fade-in">
          <div className="bg-[#111] border border-white/10 rounded-3xl p-8 max-w-md w-full">
            <h3 className="text-xl font-bold mb-6 text-center">Fecha y Hora</h3>
            
            <div className="space-y-4">
               {/* 1. INPUT DE FECHA (Mantenemos el nativo que funciona bien en móviles) */}
               <div className="relative">
                 <input 
                    type="date" 
                    value={formData.date} 
                    onChange={(e) => handleModalUpdate({ date: e.target.value })} 
                    className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white outline-none cursor-pointer [color-scheme:dark]" 
                 />
               </div>

               {/* 2. NUEVO SELECTOR DE HORA (Mejor UX) */}
               <div className="relative">
                 <select 
                    value={formData.time} 
                    onChange={(e) => handleModalUpdate({ time: e.target.value })}
                    className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white outline-none appearance-none cursor-pointer"
                 >
                    <option value="" disabled className="bg-[#111] text-gray-500">Selecciona la hora</option>
                    {timeOptions.map((opt) => (
                      <option key={opt.value} value={opt.value} className="bg-[#111] text-white py-2">
                        {opt.label}
                      </option>
                    ))}
                 </select>
                 
                 {/* Flecha personalizada para que no se vea el diseño feo por defecto del navegador */}
                 <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400">
                    <ChevronDown size={18} />
                 </div>
               </div>
            </div>

            <button 
                onClick={() => setShowDateModal(false)} 
                className="w-full mt-8 py-3.5 bg-white text-black font-bold rounded-xl active:scale-[0.98] transition-transform"
            >
                Listo
            </button>
          </div>
        </div>
      )}

      {showAddressModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-md p-4">
          <div className="bg-[#111] border border-white/10 rounded-3xl p-8 max-w-md w-full">
            <h3 className="text-xl font-bold mb-6 text-center">Dirección</h3>
            <div className="space-y-4">
              <input type="text" placeholder="Dirección" value={formData.direction} onChange={(e) => handleModalUpdate({ direction: e.target.value })} className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white outline-none" />
              <input type="text" placeholder="Ciudad o Distrito" value={formData.location} onChange={(e) => handleModalUpdate({ location: e.target.value })} className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white outline-none" />
            </div>
            <button onClick={() => setShowAddressModal(false)} className="w-full mt-6 py-3 bg-white text-black font-bold rounded-xl">Listo</button>
          </div>
        </div>
      )}

      {showVideoModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-md p-4">
          <div className="bg-[#111] border border-white/10 rounded-3xl p-8 max-w-md w-full">
            <h3 className="text-xl font-bold mb-4 text-center">Video Promocional</h3>
            <div className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-xl px-4 mb-6">
                <Video size={18} className="text-white/60" />
                <input type="url" placeholder="https://..." value={formData.video} onChange={(e) => handleModalUpdate({ video: e.target.value })} className="w-full py-3 bg-transparent text-white outline-none text-sm" />
            </div>
            <button onClick={() => setShowVideoModal(false)} className="w-full py-3 bg-white text-black font-bold rounded-xl">Listo</button>
          </div>
        </div>
      )}

      <MusicTagsModal isOpen={showTagsModal} onClose={() => setShowTagsModal(false)} selectedTags={formData.tags} onSave={(tags) => handleModalUpdate({ tags })} />

      {/* --- FORMULARIO PRINCIPAL (Layout) --- */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 pt-24 lg:pt-32 grid md:grid-cols-2 grid-cols-1 mb-16 gap-8 md:gap-16">
        {/* Columna Izq - Flyer */}
        <div className="flex flex-col items-start w-full">
            <input type="file" ref={fileInputRef} className="hidden" accept="image/*" onChange={(e) => handleImageUpload(e.target.files[0])} />
            <div onClick={() => fileInputRef.current?.click()} className="aspect-[4/5] md:aspect-square bg-white/5 w-full border border-dashed border-white/30 rounded-3xl flex items-center justify-center cursor-pointer hover:bg-white/10 transition-all relative overflow-hidden group shadow-2xl">
                {formData.image_url ? <img src={getImageUrl(formData.image_url)} className="w-full h-full object-cover" alt="Flyer"/> : <div className="text-center text-white/40"><Plus size={32} className="mx-auto mb-2"/>Subir Flyer</div>}
            </div>
        </div>

        {/* Columna Der - Datos */}
        <form onSubmit={handleSubmit} className="space-y-6 pt-2">
            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Nombre del Evento" className="w-full text-4xl font-bold bg-transparent outline-none text-white placeholder-white/20" />
            
            <div className="grid gap-4">
                <button type="button" onClick={() => setShowDateModal(true)} className={`w-full flex items-center gap-4 p-4 border rounded-2xl text-left ${formData.date ? 'bg-white/10 border-white/40' : 'bg-white/5 border-white/10'}`}>
                    <div className="bg-white/10 p-3 rounded-xl"><Clock size={20} /></div>
                    <div><span className="block font-bold">{formData.date ? format(new Date(formData.date), 'MMMM d') : 'Fecha'}</span><span className="text-sm opacity-60">{formData.time || 'Hora'}</span></div>
                </button>
                <button type="button" onClick={() => setShowAddressModal(true)} className={`w-full flex items-center gap-4 p-4 border rounded-2xl text-left ${formData.direction ? 'bg-white/10 border-white/40' : 'bg-white/5 border-white/10'}`}>
                    <div className="bg-white/10 p-3 rounded-xl"><Globe size={20} /></div>
                    <div><span className="block font-bold">{formData.direction || 'Dirección'}</span><span className="text-sm opacity-60">{formData.location || 'Ciudad'}</span></div>
                </button>
            </div>

            <textarea name="description" value={formData.description} onChange={handleChange} placeholder="Descripción..." rows="4" className="w-full px-5 py-4 bg-white/5 border border-white/10 rounded-2xl text-white outline-none resize-none" />

            {/* BOTONERA */}
            <div className="flex flex-wrap gap-3">
                <button type="button" onClick={() => setShowTagsModal(true)} className={`flex items-center gap-2 px-5 py-2.5 rounded-full border transition-all text-sm font-medium ${formData.tags.length > 0 ? 'bg-white text-black border-white' : 'bg-white/5 border-white/10 text-white/70'}`}><Music size={14}/> {formData.tags.length > 0 ? 'Música OK' : 'Música'}</button>
                
                {/* BOTÓN LINEUP ACTUALIZADO */}
                <button 
                    type="button" 
                    onClick={() => {
                        // Cargar datos existentes al modal si los hay
                        if(formData.lineup && formData.lineup.length > 0) setTempLineup(formData.lineup);
                        setShowLineupModal(true);
                    }}
                    className={`flex items-center gap-2 px-5 py-2.5 rounded-full border transition-all text-sm font-medium
                        ${formData.lineup && formData.lineup.length > 0 
                            ? 'bg-white text-black border-white shadow-[0_0_15px_rgba(255,255,255,0.2)]' 
                            : 'bg-white/5 border-white/10 text-white/70 hover:bg-white/10 hover:border-white/30'
                        }`}
                >
                    <Star size={14} />
                    {formData.lineup && formData.lineup.length > 0 ? 'Lineup Listo' : 'Lineup'}
                    {formData.lineup && formData.lineup.length > 0 && <Check size={14} />}
                </button>

                <button type="button" onClick={() => setShowVideoModal(true)} className={`flex items-center gap-2 px-5 py-2.5 rounded-full border transition-all text-sm font-medium ${formData.video ? 'bg-white text-black border-white' : 'bg-white/5 border-white/10 text-white/70'}`}><Video size={14}/> Video</button>
            </div>

            <button type="submit" disabled={!isValid} className={`w-full py-4 font-bold text-lg rounded-2xl transition-all ${isValid ? 'bg-white text-black hover:bg-gray-200' : 'bg-white/10 text-white/20 cursor-not-allowed'}`}>{isValid ? 'Lanzar Evento 🚀' : 'Completa los datos'}</button>
        </form>
      </div>
    </div>
  );
}